import moment from 'moment';

export const REASON_LABELS = {
  RIDER_REQUEST: 'Rider request',
  COMPANY_DECISION: 'Company decision',
};

export const STATUS_LABELS = {
  ACTIVE: 'Active',
  REMOVED: 'Removed',
};

export const reasonLabel = (reason) => REASON_LABELS[reason] || reason;

// The acting admin's Mongo id is a 24-char opaque string that isn't resolved to
// a name in v1 — showing it in full only eats table width. Short-form it (first
// 8 chars) for the cell and let the full id ride along in a `title` tooltip.
export const shortId = (id) => (id ? `${id.slice(0, 8)}…` : '');

export const statusLabel = (status) => STATUS_LABELS[status] || status;

// Same moment-based approach as throttleFormatters' window formatter, using the
// app's canonical DATETIME_MED shape ('MMM DD, YYYY, hh:mm A') so the created/
// removed timestamps read the same as everywhere else. Returns '' for a null/
// invalid value so a cell never renders "Invalid date".
const DATETIME_FORMAT = 'MMM DD, YYYY, hh:mm A';
export const formatDateTime = (value) => {
  if (!value) return '';
  const m = moment(value);
  return m.isValid() ? m.format(DATETIME_FORMAT) : '';
};
